// core version + navigation, pagination modules:
import siteCommon from "./site-common";
import browser from "browser-detect";

let featuredPanel = {
  browser: browser(),
  currentIndex: 0,
  numberPanels: 0,
  isHovering: 0,

  touchStartY: 0,
  touchEndY: 0,

  lastScrollTop: 0,
  debounceTimer: null,

  mode: "",
  imageProgressDurationMs: 5000,
  panelTransitionDurationMs: 2000,
  imageProgressRafId: null,
  videoProgressRafId: null,
  panelTransitionCleanupTimer: null,
  isTransitioning: false,

  // Debug toggle: set to true to pause panel auto-advance autoplay.
  pauseAutoplayForDebug: false,
  // pauseAutoplayForDebug: true,

  reachedEnd: false,
  readyToScroll: true,
  readyToEndFixed: false,
  viewportHeight: 0,
  didFirstPosterSet: false,

  init: function () {
    if ($("body").hasClass("page-home") || $("body").hasClass("is-homepage")) {
      featuredPanel.numberPanels = $("#featured-panel .panels .panel").length;

      // mobile
      $("#featured-panel").on("touchstart", function (event) {
        if (featuredPanel.mode === "tiny") {
          featuredPanel.touchStartY = event.changedTouches[0].screenY;
        }
      });

      $("#featured-panel").on("touchend", function (event) {
        if (featuredPanel.mode === "tiny") {
          featuredPanel.touchEndY = event.changedTouches[0].screenY;
          featuredPanel.handleSwipe();
        }
      });
      // $(window).on("mousewheel DOMMouseScroll", function(event) {
      //     if (featuredPanel.mode === 'tiny') {
      //         if (featuredPanel.readyToScroll === true) {
      //             clearTimeout(featuredPanel.debounceTimer);
      //             featuredPanel.debounceTimer = setTimeout(function () {
      //                 featuredPanel.readyToScroll = true
      //             }, 750);
      //             featuredPanel.readyToScroll = false
      //             let e = event.originalEvent;
      //             let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      //             let scrollTop = $(window).scrollTop();
      //             if (scrollTop <= 0){
      //                 if (delta < 0) {
      //                     featuredPanel.swipeVideoNext();
      //                 } else {
      //                     featuredPanel.swipeVideoPrev();
      //                 }
      //             }
      //             featuredPanel.lastScrollTop = $(window).scrollTop();
      //         }
      //     }
      // });
      $(window).on("resize", featuredPanel.resize);

      // menu hovers
      $("#featured-panel .arrow-links").on(
        "mouseenter",
        featuredPanel.mouseenter,
      );
      $("#featured-panel .arrow-links").on(
        "mouseleave",
        featuredPanel.mouseleave,
      );

      // clicking dots
      $("#featured-panel .dot-hook").on("click", featuredPanel.dotClick);
      $("#featured-panel .slide-prev").on("click", featuredPanel.prevClick);
      $("#featured-panel .slide-next").on("click", featuredPanel.nextClick);

      // Stop rapid/repeat clicks from starting a text selection in the surrounding slide copy.
      $("#featured-panel").on(
        "mousedown selectstart dragstart",
        ".slide-prev, .slide-next, .dot-hook",
        function (event) {
          event.preventDefault();
        },
      );

      // set first
      if ($("body").hasClass("dm")) {
        // featuredPanel.videoAutoplay();
      } else {
        featuredPanel.videoSet();
      }

      // resize
      featuredPanel.resize();
    }
  },

  // videoProgress helper
  videoProgress: function (elem) {
    if (!elem.duration) return;
    var pct = (elem.currentTime / elem.duration) * 100;
    featuredPanel.setProgress(pct);
  },

  setProgress: function (pct) {
    const safePct = Math.max(0, Math.min(100, pct));
    $(
      `#film-dot-hook .dot-hook-${featuredPanel.currentIndex} .progress`,
    ).width(safePct + "%");
    $(
      `#featured-panel .panel-hook-${featuredPanel.currentIndex} .desktop-slide-progress .progress`,
    ).width(safePct + "%");
  },

  clearImageProgressTimer: function () {
    if (featuredPanel.imageProgressRafId) {
      cancelAnimationFrame(featuredPanel.imageProgressRafId);
      featuredPanel.imageProgressRafId = null;
    }
  },

  clearVideoProgressRaf: function () {
    if (featuredPanel.videoProgressRafId) {
      cancelAnimationFrame(featuredPanel.videoProgressRafId);
      featuredPanel.videoProgressRafId = null;
    }
  },

  startVideoProgressRaf: function (elem) {
    featuredPanel.clearVideoProgressRaf();
    const tick = function () {
      if (!elem || elem.paused || elem.ended) {
        featuredPanel.videoProgressRafId = null;
        return;
      }

      const transitionLeadSeconds = featuredPanel.panelTransitionDurationMs / 1000;
      const canEarlyTransition = elem.duration > transitionLeadSeconds;
      const progressDuration = canEarlyTransition
        ? elem.duration - transitionLeadSeconds
        : elem.duration;
      const pct = progressDuration
        ? (elem.currentTime / progressDuration) * 100
        : 100;
      featuredPanel.setProgress(pct);

      const remainingMs = (elem.duration - elem.currentTime) * 1000;
      const shouldStartEarlyTransition =
        !featuredPanel.pauseAutoplayForDebug &&
        !featuredPanel.isHovering &&
        featuredPanel.numberPanels > 1 &&
        canEarlyTransition &&
        remainingMs <= featuredPanel.panelTransitionDurationMs;

      if (shouldStartEarlyTransition) {
        featuredPanel.setProgress(100);
        featuredPanel.videoProgressRafId = null;
        featuredPanel.nextPanel();
        return;
      }
      featuredPanel.videoProgressRafId = requestAnimationFrame(tick);
    };
    featuredPanel.videoProgressRafId = requestAnimationFrame(tick);
  },

  startImageProgress: function () {
    featuredPanel.clearImageProgressTimer();
    const start = Date.now();
    featuredPanel.setProgress(0);
    const tick = function () {
      const elapsed = Date.now() - start;
      const pct = (elapsed / featuredPanel.imageProgressDurationMs) * 100;
      featuredPanel.setProgress(pct);
      if (elapsed >= featuredPanel.imageProgressDurationMs) {
        featuredPanel.clearImageProgressTimer();
        featuredPanel.videoEnd();
        return;
      }
      featuredPanel.imageProgressRafId = requestAnimationFrame(tick);
    };
    featuredPanel.imageProgressRafId = requestAnimationFrame(tick);
  },

  videoAutoplay() {
    if ($("body").hasClass("page-home")) {
      if (featuredPanel.getCookie("videoAutoplay")) {
        featuredPanel.videoAutoplayDone();
      } else {
        $("body").addClass("fixed-video");
        $("#specialVideo").css("opacity", 1);
        $("#videoOverlay").show();
        var video = document.getElementById("specialVideo");
        if (!video.paused) {
          // already playing
        } else {
          video
            .play()
            .then(() => {})
            .catch((error) => {
              featuredPanel.videoAutoplayDone();
            });
        }
        video.addEventListener("ended", () => {
          featuredPanel.videoAutoplayDone();
        });
      }
      featuredPanel.setCookie("videoAutoplay", "true", 10);
    }
  },
  videoAutoplayDone() {
    $("body").removeClass("fixed-video");
    featuredPanel.videoSet();
    $("#videoOverlay").hide();
  },

  resize: function (s) {
    featuredPanel.mode = siteCommon.scGetSiteMode();
    // if (featuredPanel.mode === 'large') {
    //     featuredPanel.isHovering = false
    // } else {
    //     featuredPanel.isHovering = true
    // }
    // if (featuredPanel.reachedEnd) {
    //     $('body').removeClass('fixed')
    // } else {
    //     $('body').addClass('fixed')
    // }
    featuredPanel.videoSet(false);
    // if (featuredPanel.browser.mobile) {
    //     let viewportHeight = window.innerHeight;
    //     if (!featuredPanel.viewportHeight) {
    //         featuredPanel.viewportHeight = viewportHeight
    //         $('#featured-panel').css('height', featuredPanel.viewportHeight)
    //         $('#featured-panel').addClass('device')
    //     }
    // }
  },
  handleSwipe: function () {
    if (featuredPanel.isTransitioning) {
      return;
    }
    if (featuredPanel.touchEndY < featuredPanel.touchStartY) {
      featuredPanel.swipeVideoNext();
    }
    if (featuredPanel.touchEndY > featuredPanel.touchStartY) {
      featuredPanel.swipeVideoPrev();
    }
  },
  setTransitionLock: function (isLocked) {
    featuredPanel.isTransitioning = isLocked;
    $("#featured-panel").toggleClass("is-transitioning", isLocked);
  },
  dotClick: function () {
    if (featuredPanel.isTransitioning) {
      return;
    }
    featuredPanel.currentIndex = Number($(this).attr("data-index"));
    featuredPanel.videoSet();
  },
  resetActivePanelPlayhead: function () {
    const elem = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    )[0];
    featuredPanel.clearImageProgressTimer();
    featuredPanel.clearVideoProgressRaf();
    if (elem) {
      elem.pause();
      try {
        elem.currentTime = 0;
      } catch (error) {
        // Ignore if currentTime cannot be set for this media state.
      }
    }
    featuredPanel.setProgress(0);
  },
  nextClick: function (event) {
    event.preventDefault();
    if (featuredPanel.isTransitioning) {
      return;
    }
    featuredPanel.resetActivePanelPlayhead();
    featuredPanel.nextPanel();
  },
  prevClick: function (event) {
    event.preventDefault();
    if (featuredPanel.isTransitioning) {
      return;
    }
    featuredPanel.resetActivePanelPlayhead();
    featuredPanel.prevPanel();
  },
  nextPanel: function () {
    featuredPanel.readyToEndFixed = false;
    featuredPanel.currentIndex++;
    if (featuredPanel.currentIndex >= featuredPanel.numberPanels) {
      featuredPanel.currentIndex = 0;
    }
    featuredPanel.videoSet();
  },
  prevPanel: function () {
    featuredPanel.readyToEndFixed = false;
    featuredPanel.currentIndex--;
    if (featuredPanel.currentIndex < 0) {
      featuredPanel.currentIndex = featuredPanel.numberPanels - 1;
    }
    featuredPanel.videoSet();
  },
  mouseenter: function () {
    if ($("body").hasClass("device-notmobile")) {
      //if (featuredPanel.mode === 'large') {
      featuredPanel.isHovering = true;
      //featuredPanel.currentIndex = Number($(this).attr('data-index'))
      //featuredPanel.videoSet()
    }
  },
  mouseleave: function () {
    if ($("body").hasClass("device-notmobile")) {
      //if (featuredPanel.mode === 'large') {
      featuredPanel.isHovering = false;
    }
  },
  videoEnd: function () {
    featuredPanel.clearImageProgressTimer();
    featuredPanel.clearVideoProgressRaf();
    featuredPanel.setProgress(100);
    if (featuredPanel.pauseAutoplayForDebug) {
      return;
    }
    if (!featuredPanel.isHovering) {
      featuredPanel.nextPanel();
      return;
    }
    featuredPanel.videoSet();
  },
  swipeVideoNext: function () {
    featuredPanel.readyToEndFixed = false;
    featuredPanel.currentIndex++;
    if (featuredPanel.currentIndex >= featuredPanel.numberPanels - 1) {
      featuredPanel.currentIndex = featuredPanel.numberPanels - 1;
      featuredPanel.readyToEndFixed = true;
    }
    featuredPanel.videoSet();
  },
  swipeVideoPrev: function () {
    featuredPanel.readyToEndFixed = false;
    featuredPanel.currentIndex--;
    if (featuredPanel.currentIndex <= 0) {
      featuredPanel.currentIndex = 0;
    }
    featuredPanel.videoSet();
  },

  videoSet: function (doResize = true) {
    featuredPanel.clearImageProgressTimer();
    featuredPanel.clearVideoProgressRaf();

    // Remove existing video event handlers
    $("#featured-panel .video-hook").each(function () {
      $(this).off("play").off("ended", featuredPanel.videoEnd);
    });

    // reset progress bars
    $("#film-dot-hook .dot-hook .progress").width(0);
    $("#featured-panel .desktop-slide-progress .progress").width(0);

    const $panels = $("#featured-panel .panel-hook");
    const $incomingPanel = $(
      "#featured-panel .panel-hook-" + featuredPanel.currentIndex,
    );
    const $currentActivePanel = $panels.filter(".active").first();
    const isSameActivePanel =
      $currentActivePanel.length && $currentActivePanel.is($incomingPanel);

    $("#featured-panel .dot-hook").removeClass("active");
    $("#featured-panel .menu-hook").removeClass("active");

    if (!isSameActivePanel) {
      const $outgoingPanel = $currentActivePanel.not($incomingPanel);

      // Snap the incoming panel back to the un-wiped state without animating, so a
      // panel interrupted mid-transition still plays the full wipe on re-entry.
      $incomingPanel.addClass("is-transition-reset");
      $panels.removeClass("is-outgoing active");
      const incomingMask = $incomingPanel.find(".panel-mask")[0];
      if (incomingMask) {
        void incomingMask.offsetWidth;
      }
      $incomingPanel.removeClass("is-transition-reset");

      if ($outgoingPanel.length) {
        $outgoingPanel.addClass("is-outgoing");
      }
      $incomingPanel.addClass("active");

      if (featuredPanel.panelTransitionCleanupTimer) {
        clearTimeout(featuredPanel.panelTransitionCleanupTimer);
        featuredPanel.panelTransitionCleanupTimer = null;
      }

      featuredPanel.setTransitionLock(true);

      featuredPanel.panelTransitionCleanupTimer = setTimeout(function () {
        $("#featured-panel .panel-hook.is-outgoing").removeClass(
          "is-outgoing",
        );
        featuredPanel.panelTransitionCleanupTimer = null;
        featuredPanel.setTransitionLock(false);
      }, featuredPanel.panelTransitionDurationMs);
    }

    $("#featured-panel .dot-hook-" + featuredPanel.currentIndex).addClass(
      "active",
    );
    $("#featured-panel .menu-hook-" + featuredPanel.currentIndex).addClass(
      "active",
    );

    const desktopVideo = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    ).attr("data-desktop-video");
    const mobileVideo = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    ).attr("data-mobile-video");
    const posterImage = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    ).attr("data-poster-image");
    let mobilePosterImage = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    ).attr("data-mobile-poster-image");
    if (!mobilePosterImage) {
      mobilePosterImage = posterImage;
    }
    const elem = $(
      "#featured-panel .video-hook-" + featuredPanel.currentIndex,
    )[0];
    if (!elem) {
      return;
    }

    let oldSrc = elem.currentSrc || elem.src || "";
    let newSrc = "";
    let poster = posterImage;
    if (featuredPanel.mode === "tiny") {
      newSrc = mobileVideo || "";
      poster = mobilePosterImage;
    } else {
      newSrc = desktopVideo || "";
      poster = posterImage;
    }

    elem.poster = poster || "";

    if (!newSrc) {
      elem.pause();
      elem.removeAttribute("src");
      elem.load();
      featuredPanel.startImageProgress();
    } else {
      if (oldSrc !== newSrc || featuredPanel.didFirstPosterSet === false) {
        elem.src = newSrc;
        elem.load();
        featuredPanel.didFirstPosterSet = true;
      }

      // progress callback using jQuery
      $(elem).on("play", function () {
        featuredPanel.startVideoProgressRaf(elem);
      });

      // ended event using jQuery
      $("#featured-panel .video-hook-" + featuredPanel.currentIndex).on(
        "ended",
        featuredPanel.videoEnd,
      );

      elem
        .play()
        .then(() => {
          featuredPanel.startVideoProgressRaf(elem);
        })
        .catch(() => {
          featuredPanel.startImageProgress();
        });
    }
    $("#featured-panel").addClass("loaded");

    if (featuredPanel.readyToEndFixed) {
      featuredPanel.reachedEnd = true;
    } else {
      featuredPanel.reachedEnd = false;
    }
    if (doResize) {
      featuredPanel.resize();
    }
  },

  setCookie: function (name, value, minutes) {
    var expires = "";
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  getCookie: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
};

export default featuredPanel;
